/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CorrectionDashboardItemRepositoryResponse } from "../types/CorrectionDashboardItemRepositoryResponse.ts";

export const correctionDashboardItemRepositoryResponseSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do item do dashboard de correção."),
  ),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada à tarefa de correção.")
    .nullish(),
  startDate: z.optional(
    z.string().datetime().describe("Data de início do período de correção."),
  ),
  endDate: z.optional(
    z.string().datetime().describe("Data de término do período de correção."),
  ),
  correctionPendingCount: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de correções pendentes para a disciplina no período.",
      ),
  ),
  isOnDemand: z.optional(
    z
      .boolean()
      .describe("Indica se a disciplina é ofertada no formato on demand."),
  ),
}) as unknown as ToZod<CorrectionDashboardItemRepositoryResponse>;
